import React, { FC, useEffect, useRef, useState } from 'react';
import { ReCaptchaFieldType } from '../../types/reCaptcha.types';
import { documentService, windowService } from '../../../../utils/window.utils';

const ReCaptchaField: FC<ReCaptchaFieldType> = (props) => {
  const { field } = props;
  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement | null>(null);
  const id = field?.valueField?.id;
  const name = field?.valueField?.name;
  const placeholder = field?.model?.placeholderText;

  useEffect(() => {
    if (!field?.model.disableRecaptcha) {
      const addthisScript = documentService().createElement('script');
      addthisScript.setAttribute('src', `${field?.model?.endpointUrl}`);
      if (documentService().body) documentService().body.appendChild(addthisScript);
    }

    return () => {
      if (documentService()) {
        const reCaptchaScript = documentService()?.querySelector(`[src="${field?.model?.endpointUrl}"]`);
        if (reCaptchaScript) {
          reCaptchaScript?.remove();
        }

        const reCaptchaElement = documentService()?.querySelector('.grecaptcha-badge');
        if (reCaptchaElement) {
         reCaptchaElement?.remove();
        }
      }
    }
  }, []);

  useEffect(() => {
    if (windowService().grecaptcha && props.errors.length > 0) {
      windowService().grecaptcha.enterprise.ready(async () => {
        const token = await windowService().grecaptcha.enterprise.execute(field?.model?.siteKey, {
          action: `${field?.model?.expectedAction}`,
        });

        const stringifiedToken = windowService()?.btoa(encodeURIComponent(token));

        setValue(stringifiedToken);
        props.onChange(field.valueField.name, stringifiedToken, props.isValid, []);
        const formtag = inputRef.current?.closest('form');
        const hasGDPR = formtag?.querySelector('.sitecore-jss-form__field--gdpr');
        if (!hasGDPR) {
          (formtag?.querySelector("button[type='submit']") as HTMLButtonElement)?.click?.();
        }
      });
    }
  }, [props.errors]);

  return (
    <div className={'sitecore-jss-form__control sitecore-jss-form__control--text-box'}>
      <input
        id={id}
        name={name}
        className="sitecore-jss-form__field"
        type={'hidden'}
        ref={inputRef}
        value={value}
        placeholder={placeholder}
        form="novalidatedform"
      />
    </div>
  );
};

export default ReCaptchaField;
